import withStyles from "@material-ui/core/styles/withStyles";
import get from "lodash/get";
import moment from "moment";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  HolidayPlanInfo,
  setHelperText,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../Assets/Images/aaa.png";
import { DatePickerComponent } from "../../../../../Component/Custom";
import {
  getEJ2CalenderDateFormat,
  getFormattedDate,
} from "../../../../../Utils";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});

class HolidayApproval extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lastdateexistingemp: moment(new Date()).format("YYYY-MM-DD"),
      isnotifyexisting: true,
      dayfornewemp: "",
      isnotifynew: true,
      maxoptlimit: 1,
      helperText: "",
      showHolidayApproval: false,
      minDate: moment(new Date()).format("YYYY-MM-DD"),
      maxDate: moment(new Date()).format("YYYY-MM-DD"),
      ErDate: false,
      ErDOJ: false,
      ErNoOfOptionalHoliday: false,
      ApprovalError: false,
    };
    this.onBeforeUpload = this.onBeforeUpload.bind(this);
  }

  componentWillMount() {
    this.props.ChangeLanguage("holidayplan");
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);
    this.props.onRef({
      onNext: this.OnNext,
    });
    if (this.props.Language.holidayplan) {
      const text = this.props.Language.holidayplan.HtHolidayApproval;
      this.props.setHelperText({ helperText: text });
    }
    this.DateValidation();
    this.GetInfoFromLocalStorage();
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
    this.props.StepError(4, false);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  GetInfoFromLocalStorage() {
    const holidayPlanInfo = this.props.holidayPlanReducer;
    if (
      !this.isEmpty(holidayPlanInfo) &&
      holidayPlanInfo.isrequireoptional == false
    ) {
      this.setState({ showHolidayApproval: false });
    } else {
      const { holidayyear } = holidayPlanInfo;
      const lastdateexistingemp = holidayPlanInfo.lastdateexistingemp
        ? moment(holidayPlanInfo.lastdateexistingemp).format("YYYY-MM-DD")
        : "";
      const isnotifyexisting = holidayPlanInfo.isnotifyexisting == true;
      const { dayfornewemp } = holidayPlanInfo;
      const isnotifynew = holidayPlanInfo.isnotifynew == true;
      const { maxoptlimit } = holidayPlanInfo;
      this.setState(
        {
          showHolidayApproval: true,
          holidayyear,
          lastdateexistingemp,
          isnotifyexisting,
          dayfornewemp,
          isnotifynew,
          maxoptlimit,
        },
        () => {
          this.DateValidation();
        },
      );
    }
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
  }

  UpdateHolidayPlanInfoReducer() {
    if (this.state.showHolidayApproval) {
      // if ((!this.state.lastdateexistingemp)  ) {
      //     this.setState({  ApprovalError: false }, this.props.StepError(4, true))
      //     // this.props.enqueueSnackbar("Please select date", { variant: 'error' });
      // }
      // else if ((!this.state.dayfornewemp)) {
      //     this.setState({  ApprovalError: false }, this.props.StepError(4, true))

      // }
      // else if ((!this.state.maxoptlimit)) {
      //     this.setState({  ApprovalError: false }, this.props.StepError(4, true))

      // }

      // else {
      const holidayPlanInfo = this.props.holidayPlanReducer;
      holidayPlanInfo.lastdateexistingemp = this.state.lastdateexistingemp
        ? this.state.lastdateexistingemp
        : null;
      holidayPlanInfo.isnotifyexisting = this.state.isnotifyexisting;
      holidayPlanInfo.dayfornewemp = this.state.dayfornewemp
        ? this.state.dayfornewemp
        : null;
      holidayPlanInfo.isnotifynew = this.state.isnotifynew;
      holidayPlanInfo.maxoptlimit = this.state.maxoptlimit
        ? this.state.maxoptlimit
        : null;
      this.props.HolidayPlanInfo({ ...holidayPlanInfo });
      if (
        this.state.lastdateexistingemp &&
        this.state.dayfornewemp &&
        this.state.maxoptlimit
      ) {
        this.props.StepError(4, false);
      }
      // this.setState({ ApprovalError: true })
      // }
    }
  }

  HandleNext() {
    // console.log("handlenext2");
    // if (this.state.ApprovalError && this.state.showHolidayApproval) {
    //     console.log("handlenext21");
    //     this.props.click()
    // } else {

    this.props.click();
    this.UpdateHolidayPlanInfoReducer();
    // }
  }

  OnNext = () => {
    if (this.state.showHolidayApproval) {
      if (this.state.lastdateexistingemp == "") {
        this.setState({ ErDate: true, ApprovalError: true }, () => {
          this.props.StepError(4, true);
          // this.HandleNext();
        });
      } else if (!this.state.isnotifyexisting) {
        this.props.StepError(4, true);
        this.props.enqueueSnackbar(
          "Please select send notification for existing employee",
          { variant: "error" },
        );
      } else if (!this.state.isnotifynew) {
        this.props.StepError(4, true);
        this.props.enqueueSnackbar(
          "Please select send notification for new employee",
          { variant: "error" },
        );
      } else if (!this.state.maxoptlimit) {
        this.setState(
          { ErNoOfOptionalHoliday: true, ApprovalError: true },
          () => {
            this.props.StepError(4, true);
            // this.HandleNext();
          },
        );
      } else {
        this.setState({ ApprovalError: false }, () => this.HandleNext());
      }
    } else {
      this.HandleNext();
    }
    // else if (!this.state.dayfornewemp) {
    //     this.setState({ ErDOJ: true, ApprovalError: true }, () => {
    //         this.props.StepError(4, true);
    //         // this.HandleNext();
    //      })
    // }
  };

  HelperSliderFlag(HtField) {
    const text = get(this.props, `Language.holidayplan[${HtField}]`);
    // let text = this.props.Language.holidayplan[HtField]
    this.props.setHelperText({ helperText: text, open: true });
  }

  DateValidation() {
    const minDate = moment(new Date()).format("YYYY-MM-DD");
    let maxDate;
    const CurrentYear = new Date().getFullYear();
    if (this.state.holidayyear) {
      maxDate = `${this.state.holidayyear}-12-31`;
    } else {
      maxDate = `${CurrentYear}-12-31`;
    }
    this.setState({ minDate, maxDate });
  }

  ConvertDate(str) {
    const date = new Date(str);
    const mnth = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  SelectDate(a, args) {
    // this.HelperSliderFlag(['HtlLastDateExistingEmp'])
    let lastdateexistingemp;
    if (args.value) {
      const date = this.ConvertDate(args.value);
      lastdateexistingemp = date;

      const datenew = moment(new Date(args.value)).endOf("year");
      this.setState(
        {
          lastdateexistingemp,
          ErDate: false,
          leaveexpiredate: getFormattedDate(datenew),
        },
        () => {
          this.UpdateHolidayPlanInfoReducer();
        },
      );
    }
  }

  SetIsNotifyExistingFlag() {
    this.HelperSliderFlag("HtIsNotifyExistingFlag");
    const isnotifyexisting = !this.state.isnotifyexisting;
    this.setState({ isnotifyexisting }, () => {
      this.UpdateHolidayPlanInfoReducer();
    });
  }

  UpdateDayForNewEmp(event) {
    this.HelperSliderFlag("HtDayForNewEmp");
    let dayfornewemp;
    if (
      event.target.value < 1 ||
      Number.isNaN(event.target.value) ||
      event.target.value > 180
    ) {
      dayfornewemp = "";
    } else {
      dayfornewemp = event.target.value;
    }
    this.setState({ dayfornewemp, ErDOJ: false }, () => {
      this.UpdateHolidayPlanInfoReducer();
    });
  }

  SetIsIsNotifyNewFlag() {
    this.HelperSliderFlag("HtIsNotifyNewFlag");
    const isnotifynew = !this.state.isnotifynew;
    this.setState({ isnotifynew }, () => {
      this.UpdateHolidayPlanInfoReducer();
    });
  }

  UpdateMaxOptLimit(event) {
    let maxoptlimit;
    if (
      event.target.value < 1 ||
      Number.isNaN(event.target.value) ||
      event.target.value > 60
    ) {
      maxoptlimit = "";
    } else {
      maxoptlimit = event.target.value;
    }
    this.setState({ maxoptlimit, ErNoOfOptionalHoliday: false }, () => {
      this.UpdateHolidayPlanInfoReducer();
    });
  }

  HandleKeyDown(e) {
    if ([69, 187, 188, 189, 190, 107, 109, 110].includes(e.keyCode)) {
      e.preventDefault();
    }
  }

  render() {
    const { classes } = this.props;

    const language = this.props.Language.holidayplan;
    return (
      <IntlProvider locale="en" messages={language}>
        <div className={classes.root}>
          <div className="stepper-scroller padding-top-0">
            <div className="stepper-scroller-content">
              <div className="device-wrapper opaque">
                {this.state.showHolidayApproval ? (
                  <div>
                    <div>
                      <p className="depedent-select-list-head">
                        <FormattedMessage
                          id="LbByWhichDate"
                          defaultMessage="By which date should the employee select his/her optional holidays?"
                        />
                      </p>
                      <p className="depedent-select-list-head add-label-active">
                        <FormattedMessage
                          id="LbExistingEmployees"
                          defaultMessage="Existing Employees"
                        />
                      </p>
                      <div className="Approval">
                        <span>
                          <FormattedMessage id="LbOn" defaultMessage="On" />{" "}
                        </span>
                        <div>
                          <DatePickerComponent
                            depth="Month"
                            start="Decade"
                            width="30%"
                            allowEdit={false}
                            format={getEJ2CalenderDateFormat()}
                            // border="1px solid #166ab3 !important"
                            min={this.state.minDate}
                            max={this.state.maxDate}
                            // onClick={() => this.dateObj.show()}
                            // ref={(date)) => this.dateObj = date}
                            change={(e) => this.SelectDate("date", e)}
                            // value={new Date(this.state.lastdateexistingemp)}
                            value={this.state.lastdateexistingemp}
                          />
                        </div>
                        {this.state.ErDate == true ? (
                          <span className="caption-error">
                            <FormattedMessage
                              id="ErDate"
                              defaultMessage="Please select date"
                            />
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="padding-top-20">
                      <p className="depedent-select-list-head">
                        <FormattedMessage
                          id="LbIfNotSelectedThen"
                          defaultMessage="If not selected then"
                        />
                      </p>
                      <div
                        className={
                          this.state.isnotifyexisting == true
                            ? "depedent-select-list select-list-item"
                            : "depedent-select-list"
                        }
                        onClick={this.SetIsNotifyExistingFlag.bind(this)}
                      >
                        <span>
                          <FormattedMessage
                            id="LbSendEmailNotificationToManager"
                            defaultMessage="Send email notification to manager"
                          />
                        </span>
                        {this.state.isnotifyexisting == true ? (
                          <span className="floatright">
                            <img src={CheckImg} height="20" />
                          </span>
                        ) : (
                          <span className="not-selected"></span>
                        )}
                      </div>
                      <div className="bottom-border"></div>
                    </div>
                    <div className="padding-top-20">
                      <p className="depedent-select-list-head add-label-active">
                        <FormattedMessage
                          id="LbNewEmployees"
                          defaultMessage="New Employees"
                        />
                      </p>
                      <div className="">
                        <span>
                          <FormattedMessage
                            id="LbWithin"
                            defaultMessage="Within"
                          />{" "}
                        </span>
                        {/* <span className='number-wrapper'> */}
                        <input
                          type="number"
                          className="seatlimit"
                          style={{
                            width: 90,
                            padding: "2px 0px 2px 8px",
                            fontSize: 30,
                          }}
                          min={1}
                          max={365}
                          placeholder="00"
                          value={this.state.dayfornewemp}
                          onChange={this.UpdateDayForNewEmp.bind(this)}
                          onKeyDown={this.HandleKeyDown.bind(this)}
                        />
                        {/* </span> */}
                        <div style={{ marginBottom: 30 }}>
                          {" "}
                          <span>
                            <FormattedMessage
                              id="LbDaysOfJoining"
                              defaultMessage="Days Of Joining"
                            />{" "}
                          </span>
                        </div>

                        <span>
                          <FormattedMessage
                            id="#"
                            defaultMessage="Note: If you don't set any restriction for selection of optional holidays,
                                                then new employees will be able to choose their optional holidays upto the end of your calender cycle."
                          />
                        </span>
                      </div>
                      {this.state.ErDOJ == true ? (
                        <span className="caption-error">
                          <FormattedMessage
                            id="ErDOJ"
                            defaultMessage="Please add days limit"
                          />
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="padding-top-20">
                      <p className="depedent-select-list-head">
                        <FormattedMessage
                          id="LbIfNotSelectedThen"
                          defaultMessage="If not selected then"
                        />
                      </p>
                      <div
                        className={
                          this.state.isnotifynew == true
                            ? "depedent-select-list select-list-item"
                            : "depedent-select-list"
                        }
                        onClick={this.SetIsIsNotifyNewFlag.bind(this)}
                      >
                        <span>
                          <FormattedMessage
                            id="LbSendEmailNotificationToManager"
                            defaultMessage="Send email notification to manager"
                          />
                        </span>
                        {this.state.isnotifynew == true ? (
                          <span className="floatright">
                            <img src={CheckImg} height="20" />
                          </span>
                        ) : (
                          <span className="not-selected"></span>
                        )}
                      </div>
                      <div className="bottom-border"></div>
                    </div>
                    <div className="padding-top-20">
                      <p className="depedent-select-list-head">
                        <FormattedMessage
                          id="LbWhatAreTheMaximumNumber"
                          defaultMessage="What are the maximum number of optional holidays an employee can select ?"
                        />
                      </p>
                      <div>
                        <input
                          type="number"
                          className="seatlimit"
                          style={{
                            width: 70,
                            padding: "2px 0px 2px 8px",
                            fontSize: 30,
                          }}
                          min={1}
                          max={20}
                          value={this.state.maxoptlimit}
                          onChange={this.UpdateMaxOptLimit.bind(this)}
                          onKeyDown={this.HandleKeyDown.bind(this)}
                        />
                        <span>
                          <FormattedMessage
                            id="LbOptionalHolidays"
                            defaultMessage="optional holidays"
                          />{" "}
                        </span>
                      </div>
                      {this.state.ErNoOfOptionalHoliday == true ? (
                        <span className="caption-error">
                          <FormattedMessage
                            id="ErNoOfOptionalHoliday"
                            defaultMessage="Please add numer of optional holidays"
                          />
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                ) : (
                  <div>
                    <p className="depedent-select-list-head">
                      <FormattedMessage
                        id="LbOptionalSelectionRestricted"
                        defaultMessage="Optional Selection is restricted"
                      />
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </IntlProvider>
    );
  }
}

HolidayApproval.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  holidayPlanReducer: state.holidayPlanReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      HolidayPlanInfo: (data) => HolidayPlanInfo(data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(HolidayApproval)));
